import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';
import type { Insight } from '../insightsData';

interface InsightCardProps {
  insight: Insight;
}

const InsightCard = ({ insight }: InsightCardProps) => {
  return (
    <article className="group">
      <Link
        href={`/insights/${insight.slug}`}
        className="block transition-transform duration-200 ease-confident active:scale-[0.99]"
      >
        <div className="relative overflow-hidden rounded-2xl mb-3 aspect-16/10">
          <AppImage
            src={insight.image}
            alt={insight.alt}
            className="w-full h-full object-cover transition-transform duration-500 ease-confident group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-linear-to-t from-background/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        </div>

        <div className="space-y-4">
          <div className="flex items-center gap-4 text-xs font-cta text-muted-foreground">
            <span className="text-primary">{insight.category}</span>
            <span className="flex items-center gap-1">
              <Icon name="ClockIcon" size={14} />
              {insight.readTime} min read
            </span>
            <span>{insight.publishDate}</span>
          </div>

          <h3 className="font-headline text-xl font-bold text-foreground group-hover:text-primary transition-colors duration-300 line-clamp-2">
            {insight.title}
          </h3>

          <p className="font-body text-base text-muted-foreground line-clamp-3 leading-relaxed">
            {insight.excerpt}
          </p>

          <div className="flex items-center gap-3 pt-2">
            <div className="flex w-10 h-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-cta text-sm font-semibold">
              {insight.author.initials}
            </div>
            <div>
              <p className="font-cta text-sm font-medium text-foreground">{insight.author.name}</p>
              <p className="font-body text-xs text-muted-foreground">{insight.author.role}</p>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
};

export default InsightCard;
